import React from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';

import styled from 'styled-components';
import blueStrategy from '../../../assets/BlueStrategy.png';
import { colorConfig } from '../../../config/colors';
import { StrategyHeader } from '../../../components/StrategyHeader';

const Box = styled.div`
  gap: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1,
  h2 {
    text-align: center;
  }
  img {
    margin-left: -100px;
  }
`;

export const Rules7 = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data }) => {
    const { t } = useTranslation();

    return (
      <Wrapper>
        <Box>
          <img src={blueStrategy} alt="blue" height="300px" />
          <div>
            <StrategyHeader>
              <h1 dangerouslySetInnerHTML={{ __html: t('fishery.rules7', { strategyColor: colorConfig.blue.card }) }} />
            </StrategyHeader>
            <h2>{t('fishery.rules7a')}</h2>
          </div>
        </Box>
      </Wrapper>
    );
  },
});
